// extracted by mini-css-extract-plugin
export default {"ModalContent":"ModalLayout_ModalContent__+gI43","BetaModal":"ModalLayout_BetaModal__-vKmN","Close":"ModalLayout_Close__EAw1c"};